module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#sports",
      toString: function () {
        return this.url;
      }
    }